import { IonText } from '@ionic/react';

import styles from './NewPasswordHint.module.scss';

interface NewPasswordHintProps {
  errorMessage: string | null;
}

/** Bajo los campos de nueva clave: el error de validación (si lo hay) y siempre la recomendación */
export default function NewPasswordHint({ errorMessage }: NewPasswordHintProps) {
  return (
    <div className={styles.container}>
      {errorMessage && (
        <IonText className={styles.error} role="alert">
          {errorMessage}
        </IonText>
      )}
      <IonText className={styles.hint}>
        Evita que sean todos iguales o que formen una secuencia consecutiva, como 123456 o 987654.
        No reutilices tu contraseña anterior.
      </IonText>
    </div>
  );
}
